import { useState } from 'react';
import { apiCall } from '../api/client';
import logo from '../components/BeeFluent logos/beefluent_logo_512.png';

export default function SetupUsername({ token, onComplete }) {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await apiCall('PATCH', '/me', { username }, token);
      onComplete(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-amber-50 flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-md p-6 sm:p-8 w-full max-w-md">
        <img src={logo} alt="BeeFluent logo" className="h-16 w-auto mx-auto mb-3" />
        <h2 className="text-3xl font-bold text-amber-600 mb-2 text-center">Welcome!</h2>
        <p className="text-amber-700 mb-6 text-center">Choose a username to get started.</p>

        {error && <p className="text-red-500 text-sm mb-4 text-center">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-amber-800 mb-1">Username</label>
            <input
              type="text"
              value={username}
              onChange={e => setUsername(e.target.value)}
              className="w-full border border-amber-200 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-amber-400"
              required
              minLength={2}
              maxLength={30}
              autoFocus
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-amber-500 hover:bg-amber-600 text-white font-semibold py-2 rounded-lg transition disabled:opacity-50"
          >
            {loading ? 'Saving...' : 'Get started'}
          </button>
        </form>
      </div>
    </div>
  );
}
